import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Home from "@/pages/Home";
import ProjectsListing from "@/pages/ProjectsListing";
import ProjectDetail from "@/pages/ProjectDetail";
import Admin from "@/pages/Admin";
import AdminLoginPage from "@/pages/AdminLoginPage";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.08,
      smoothWheel: true,
      wheelMultiplier: 0.9,
    });
    let frameId;

    const raf = (time) => {
      lenis.raf(time);
      frameId = requestAnimationFrame(raf);
    };

    frameId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frameId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-[#F5F5F5] font-body text-[#0B1F3B]" data-testid="app-shell">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<><Header /><Home /><Footer /></>} />
          <Route path="/projects" element={<><Header /><ProjectsListing /><Footer /></>} />
          <Route path="/projects/:projectId" element={<><Header /><ProjectDetail /><Footer /></>} />
          <Route path="/admin/login" element={<><Header /><AdminLoginPage /></>} />
          <Route path="/admin" element={<><Header /><Admin /><Footer /></>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
